module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-month-fill-2a8829de.svg";